<template>
  <div>
    <br />
    <table class="table table-bordered">
      <thead>
        <tr>
          <th class="text-center" width="50">
            <button class="btn btn-success" @click="addRow">
              <i class="fa fa-plus-circle" aria-hidden="true"></i>
            </button>
          </th>
          <th class="text-left" width="250">Item</th>
          <th class="text-left" width="120">Category 1</th>
          <th class="text-left" width="120">Category 2</th>
          <th class="text-center" width="50">Quantity</th>
          <th class="text-center" width="50">Unit</th>
          <th class="text-center" width="80">Unit Price</th>
          <th class="text-center" width="80">Total Price</th>
          <th width="50"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td class="text-center">{{ index + 1 }}.</td>
          <td>
            <item-select
              :item="item"
              :selectedIndex="index"
              @input="pickDress"
            />
            <!-- <textarea :class="'form-control '+errorClassOnNull(item.name)" v-model="item.name" rows="1" placeholder="Item Description"></textarea> -->
          </td>
          <td class="text-right">
            <input type="text" class="form-control" v-model="item.category_1" />
          </td>
          <td class="text-right">
            <input type="text" class="form-control" v-model="item.category_2" />
          </td>
          <td class="text-center">
            <input
              type="number"
              :class="'form-control text-center ' + errorClass(item.quantity)"
              v-model="item.quantity"
            />
          </td>
          <td class="text-right">
            <input
              type="text"
              class="form-control text-center"
              v-model="item.unit"
            />
          </td>
          <td class="text-right">
            <input
              type="number"
              class="form-control text-right"
              v-model="item.unit_price"
            />
          </td>
          <td class="text-right">
            {{ ezy.comma(totalPrice(item, index)) }}
          </td>
          <td class="text-center">
            <button class="btn btn-danger" @click="delRow(index)">
              <i class="fa fa-trash-o" aria-hidden="true"></i>
            </button>
          </td>
        </tr>

        <tr>
          <td colspan="6" rowspan="4">
            <textarea
              class="form-control"
              v-model="invoice.invoice_note"
              rows="5"
              placeholder="Comment"
            >
            </textarea>
          </td>
          <td class="text-right">Total</td>
          <td class="text-right">
            {{ ezy.comma(footerTotal()) }}
          </td>
          <td class="text-center">{{ this.currency }}</td>
        </tr>
        <tr>
          <td class="text-right">
            VAT
            <input type="text" class="vat" v-model="invoice.vat_percent" /> %
          </td>
          <td class="text-right">
            {{ ezy.comma(footerVat()) }}
          </td>
          <td class="text-center">{{ this.currency }}</td>
        </tr>
        <tr>
          <td class="text-right">
            WHT
            <input type="text" class="vat" v-model="invoice.wht_percent" /> %
          </td>
          <td class="text-right">
            {{ ezy.comma(footerWht()) }}
          </td>
          <td class="text-center">{{ this.currency }}</td>
        </tr>
        <tr>
          <td class="text-right">Grand Total</td>
          <td class="text-right">
            {{ ezy.comma(footerGrandTotal()) }}
          </td>
          <td class="text-center">{{ this.currency }}</td>
        </tr>
        <tr>
          <td colspan="6">
            <button class="btn btn-info" @click="fileUploadModal()">
              <i class="fa fa-paperclip" aria-hidden="true"></i>
            </button>
            &nbsp;&nbsp; <i class="fa fa-info-circle" aria-hidden="true"></i> (
            JPGE, JPG, PNG AND PDF ONLY )
            <input
              type="file"
              style="display: none"
              id="attachment"
              accept="application/pdf, image/png, image/jpg, image/jpeg"
              multiple="multiple"
              @change="fileChange()"
            />
          </td>
          <td class="text-right">Bank Transfer Fee</td>
          <td class="text-right">
            <input
              type="number"
              class="form-control text-right"
              v-model="invoice.bank_transfer_fee"
            />
          </td>
          <td class="text-center">{{ this.currency }}</td>
        </tr>
      </tbody>
    </table>

    <a
      :href="invoice.attachments"
      target="_blank"
      class="badge badge-success mr-2 pointer"
      v-if="invoice.attachments"
    >
      <i class="fa fa-paperclip" aria-hidden="true"></i> Invoice.pdf
      <i
        class="fa fa-times text-danger pointer"
        aria-hidden="true"
        @click="removeAttachments($event)"
      ></i>
    </a>

    <p
      class="badge badge-success mr-2"
      v-for="(fileName, index) in fileNames"
      :key="index"
    >
      <i class="fa fa-paperclip" aria-hidden="true"></i> {{ fileName.name }} ({{
        fileName.size
      }})
      <i
        class="fa fa-times text-danger pointer"
        aria-hidden="true"
        @click="removeFile(index)"
      ></i>
    </p>
  </div>
</template>

<script>
import ezy from "../Tools/ezyFunction";
import ItemSelect from "./ItemSelect";
import Swal from "sweetalert2";
export default {
  components: {
    ItemSelect,
  },
  props: ["items", "invoice", "files"],
  data() {
    return {
      ezy: ezy,
      currency: "THB",
      fileNames: [],
    };
  },
  methods: {
    pickDress(item) {
      var index = item["selectedIndex"];
      if (item.name) {
        this.items[index].name = item.name;
        this.items[index].category_1 = item.category_1;
        this.items[index].category_2 = item.category_2;
        this.items[index].unit_price = item.unit_price;
      } else {
        this.items[index].name = null;
        this.items[index].category_1 = null;
        this.items[index].category_2 = null;
        this.items[index].unit_price = null;
      }
    },
    addRow() {
      let item = {
        name: null,
        category_1: null,
        category_2: null,
        quantity: 1,
        unit: "Pcs",
        unit_price: 0,
        total_price: 0,
      };
      this.items.push(item);
    },
    delRow(index) {
      this.items.splice(index, 1);
    },
    totalPrice(item, index) {
      this.items[index]["total_price"] = item.unit_price * item.quantity;
      return this.items[index]["total_price"];
    },
    footerTotal() {
      let items = this.items;
      let total = 0;
      items.forEach((val) => {
        total += val.quantity * val.unit_price;
      });
      this.invoice.total_price = total;
      return total;
    },
    footerVat() {
      let percent = this.invoice.vat_percent;
      let vat = this.footerTotal() * (percent / 100);
      this.invoice.vat = vat;
      return vat;
    },
    footerWht() {
      let percent = this.invoice.wht_percent;
      let wht = this.footerTotal() * (percent / 100);
      this.invoice.wht = wht;
      return wht;
    },
    footerGrandTotal() {
      let grandTotal = this.footerTotal() + this.footerVat() - this.footerWht();
      this.invoice.grand_total = grandTotal;
      return grandTotal;
    },
    fileUploadModal() {
      $("#attachment").click();
    },
    fileChange() {
      var ele = document.getElementById("attachment");
      var result = ele.files;
      let self = this;

      if (ele.files.length > 0) {
        for (var i = 0; i <= ele.files.length - 1; i++) {
          var name = ele.files.item(i).name;
          let size = ezy.bytesToSize(ele.files.item(i).size);
          var ext = name.split(".").pop().toLowerCase();
          var extensions = ["png", "jpg", "jpeg", "pdf"];
          if (extensions.includes(ext)) {
            self.files.push(ele.files.item(i));
            self.fileNames.push({ name, size });
          }
        }
      }
      this.checkFiles();
    },
    removeFile(index) {
      this.fileNames.splice(index, 1);
      this.files.splice(index, 1);
    },
    errorClass(quantity) {
      if (quantity < 1) {
        return "error-input";
      }
    },
    async removeAttachments(event) {
      event.preventDefault();
      const { value: value } = await Swal.fire({
        type: "warning",
        title: "Are You Sure?",
        showCancelButton: true,
      });
      if (value) {
        this.invoice.attachments = null;
      }
    },
    checkFiles() {
      let limit = 10;
      if (this.files.length > limit) {
        this.files.splice(limit, this.files.length);
        this.fileNames.splice(limit, this.fileNames.length);

        Swal.fire(
          "WARNING !",
          `You Selected More than ${limit} Files!`,
          "warning"
        );
      }
    },
  },
  mounted() {
    this.addRow();
  },
};
</script>

<style scoped>
.vat {
  min-height: 23px !important;
  width: 40px;
  margin-top: -3px;
  font-weight: bold;
  text-align: right;
}
.error-input {
  border: 1px solid red !important;
}
</style>
